module.exports = __webpack_public_path__ + "media/images/help/delivery/eyecatch-calendar-normal-0d3b7fcbf1d8505150ec3334ed2c95d0.svg";